import { render, staticRenderFns } from "./charge.vue?vue&type=template&id=12637d3e&scoped=true&"
import script from "./charge.vue?vue&type=script&lang=js&"
export * from "./charge.vue?vue&type=script&lang=js&"
import style0 from "./charge.vue?vue&type=style&index=0&id=12637d3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12637d3e",
  null
  
)

export default component.exports